import { Component, DestroyRef, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { UnpaidPartnerTileSummaryService } from './unpaid-partner-tile-summary.service';
import { UnpaidPaymentsAccessService } from './unpaid-payments-access.service';
import { UnpaidPaymentsHubOverviewService } from './unpaid-payments-hub-overview.service';

@Component({
  selector: 'app-unpaid-payments-v2-parent',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './unpaid-payments-v2-parent.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./unpaid-payments-v2-parent.component.scss'],
})
export class UnpaidPaymentsV2ParentComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly hubOverviewService = inject(UnpaidPaymentsHubOverviewService);
  private readonly accessService = inject(UnpaidPaymentsAccessService);

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    readonly partnerTileSummary: UnpaidPartnerTileSummaryService
  ) {}

  ngOnInit(): void {
    this.hubOverviewService.prepareOverviewCards();
    this.hubOverviewService.loadCards();
    this.hubOverviewService.startAutoRefresh();
    this.destroyRef.onDestroy(() => this.hubOverviewService.stopAutoRefresh());

    if (!this.route.firstChild) {
      toObservable(this.accessService.probingComplete)
        .pipe(
          filter((complete) => complete),
          take(1),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(() => {
          const target = this.accessService.firstAccessibleRouteSegment();
          this.router.navigate([target], { relativeTo: this.route, replaceUrl: true });
        });
    }
  }
}
